package com.devi3east.bashbuddy.dashboard.responses

import com.devi3east.bashbuddy.prizeList.domain.models.Prize
import kotlinx.serialization.Serializable

@Serializable
data class PrizeListResponse(
    val prizes: List<Prize> = emptyList()
)